module.exports = __webpack_public_path__ + "static/media/LogoQrpedir.739ebecd.svg";